const eventType = {
  LIVE_DROP: 'LIVE_DROP',
  BEST_DROP: 'BEST_DROP',
  STATS: 'STATS',
  ONLINE: 'ONLINE',
  INVENTORY_UPDATE: 'INVENTORY_UPDATE',
  PROFILE_UPDATE: 'PROFILE_UPDATE',
  TRADE_UPDATE: 'TRADE_UPDATE',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  CASE_UPDATE: 'CASE_UPDATE',
  EXCHANGE_OFFER: 'EXCHANGE_OFFER',
  SAFEBOX_ATTEMPT: 'SAFEBOX_ATTEMPT',
  SAFEBOX_WON: 'SAFEBOX_WON',
  CRYPTO_ADDRESS: 'CRYPTO_ADDRESS',
  ARENA_CREATED: 'ARENA_CREATED',
  ARENA_JOINED: 'ARENA_JOINED',
  ARENA_START: 'ARENA_START',
  ARENA_ROUND: 'ARENA_ROUND',
  ARENA_FINISHED: 'ARENA_FINISHED',
  ARENA_UPDATE: 'ARENA_UPDATE',
  ARENA_PARTICIPANT_READY: 'ARENA_PARTICIPANT_READY',
  COINPAYMENTS_DEPOSIT_STATUS: 'COINPAYMENTS_DEPOSIT_STATUS',
  COINPAYMENTS_DEPOSIT_COMPLETE: 'COINPAYMENTS_DEPOSIT_COMPLETE',
  // GIVEAWAYS
  GIVEAWAY_ACTIVE: 'GIVEAWAY_ACTIVE',
  GIVEAWAY_END: 'GIVEAWAY_END',
  GIVEAWAY_JOIN: 'GIVEAWAY_JOIN',
  GIVEAWAY_PICKING: 'GIVEAWAY_PICKING',
  GIVEAWAY_CREATED: 'GIVEAWAY_CREATED',

  // SKIN CLASH
  SKIN_CLASH_JOIN: 'SKIN_CLASH_JOIN',
  SKIN_CLASH_ACTIVE: 'SKIN_CLASH_ACTIVE',
  SKIN_CLASH_END: 'SKIN_CLASH_END',

  // SKINS DEPOSIT
  SKINSBACK_DEPOSIT_INSTANT_CREDIT: 'SKINSBACK_DEPOSIT_INSTANT_CREDIT',
  SKINSBACK_DEPOSIT_COMPLETED: 'SKINSBACK_DEPOSIT_COMPLETED',

  // PROMOTIONAL EVENTS
  PROMOTIONAL_EVENT_ACTIVATED: 'PROMOTIONAL_EVENT_ACTIVATED',
  PROMOTIONAL_EVENT_ENDED: 'PROMOTIONAL_EVENT_ENDED',
  WHALE_POINTS_AWARDED: 'WHALE_POINTS_AWARDED',
  LEADERBOARD_UPDATED: 'LEADERBOARD_UPDATED',
  PROMOTIONAL_EVENT_WP_UPDATE: 'PROMOTIONAL_EVENT_WP_UPDATE',
  ACTIVITY_FEED: 'ACTIVITY_FEED',
} as const

export type SseEvent = (typeof eventType)[keyof typeof eventType]
export default eventType
